import { render, staticRenderFns } from "./PointDistributionQuestion.vue?vue&type=template&id=d8d58b3a"
import script from "./PointDistributionQuestion.vue?vue&type=script&lang=js"
export * from "./PointDistributionQuestion.vue?vue&type=script&lang=js"
import style0 from "./PointDistributionQuestion.vue?vue&type=style&index=0&id=d8d58b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports